<template>
  <div id="darker"></div>
  <WelcomeModal />
  <heads v-if="$route.meta.shell === 'modern'"/>
  <ShinaiLoading v-if="$route.meta.shell === 'modern'"/>
  <router-view :key="$route.fullPath"/>
</template>

<script>
import { mapActions } from 'vuex'
import heads from '@/components/heads.vue'
import ShinaiLoading from '@/components/Loading/ShinaiLoading.vue'
import WelcomeModal from '@/components/WelcomeModal.vue'

export default {
  name: 'App',
  components: { heads, ShinaiLoading, WelcomeModal },
  methods: {
    ...mapActions(['init_library', 'dispose_library']),
    preventNativeDrag(event) {
      event.preventDefault()
    },
  },
  mounted() {
    document.addEventListener('dragstart', this.preventNativeDrag, true)
    this.init_library()
  },
  beforeUnmount() {
    document.removeEventListener('dragstart', this.preventNativeDrag, true)
    this.dispose_library()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Oswald:wght@700&family=Roboto&family=Roboto+Mono&family=Varela+Round&display=swap');

:root {
  --background: #000000;
  --anime-url: url(@/assets/wallpaper.png);
  --film-url: url(@/assets/wallpaper2.png);
}
@font-face {
  font-family: "Shinai";
  src: url("@/fonts/electroharmonix.ttf");
}
.darker-active
{ position: absolute; width: 100%; height: 300%; z-index: 3; background-color: rgba(0, 0, 0, 0.31); }

.disable-scrolling{ height: 100%; overflow: hidden; }

html {
  min-height: 100%;
  background: var(--background);
  overscroll-behavior-y: none;
}
html:not(.scrollbars-visible),
html:not(.scrollbars-visible) * {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
html:not(.scrollbars-visible)::-webkit-scrollbar,
html:not(.scrollbars-visible) *::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
body,
#app {
  min-height: 100%;
}
body {
  margin: 0;
  padding: 0;
  background: var(--background);
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -webkit-user-select: none;
  user-select: none;
}
body,
body * {
  -webkit-user-drag: none;
}
button,
a,
input {
  touch-action: manipulation;
}
.tc { text-align: center; margin: 0; padding: 0; }
.left {  margin-left: 8px; }
.right {  margin-right: 8px; }
.unselectable { user-select: none; -moz-user-select: none; -khtml-user-select: none; -webkit-user-select: none; -o-user-select: none; }
.selectable-text,
.selectable-text *,
input,
textarea,
[contenteditable]:not([contenteditable="false"]),
[role="textbox"] {
  -webkit-user-select: text;
  user-select: text;
}
.default-img { width: 193.536px; height: 276.486px; transition: 0.3s; border-radius: 3.5px; }
.default-bold-p { 
  font-family: 'Inter';
  font-weight: 600;
  font-size: 24px;
  margin: 0; padding: 0;
}
.default-regular-p { 
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 19px;
  margin: 0; padding: 0;
}
@keyframes show_in_default {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
@keyframes show_in {
    from {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.8);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}
@keyframes search_show_in {
    from {
        opacity: 0;
        width: 0;
    }
    to {
        opacity: 1;
        width: 100%;
    }
}
/* ANIMATION STANDART 
  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  transform: scale(0.0) translateY(330px);
  transition: 0.3s;
  opacity: 0;
  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  opacity: 1;
  transform: scale(1) translateY(0px);
  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
*/


::selection { background-color: #ea2d2d; color: #ffffff; text-shadow: none; }
::-moz-selection { background-color: #ea2d2d; color: #ffffff; text-shadow: none; }
::-o-selection { background-color: #ea2d2d; color: #ffffff; text-shadow: none; }
::-ms-selection { background-color: #ea2d2d; color: #ffffff; text-shadow: none; }
::-webkit-selection { background-color: #ea2d2d; color: #ffffff; text-shadow: none; }

.highlight { color: #E30053; text-shadow: 2px 3px 14.3px #E30053; font-weight: 600; }
.highlight-border { padding: 5px 15px 5px 15px; border: 2px solid #E30053; border-radius: 10px; background: #e3005342 }
.highlight-document { background: #ea2d2d; }

.performance-lite .poster-image::after,
.performance-lite .content_img::before,
.performance-lite .watch-order-skeleton,
.performance-lite .circle-large,
.performance-lite .circle-small {
  animation: none !important;
}
.performance-lite .poster-button-selected::after,
.performance-lite .poster-shell-selected::after,
.platform-webos .poster-button-selected::after,
.platform-webos .poster-shell-selected::after {
  bottom: -4% !important;
  width: 48% !important;
  height: 20% !important;
  filter: blur(32px) saturate(1.3) !important;
  opacity: .7 !important;
}
.performance-lite .desktop-navigation,
.performance-lite .search-input,
.performance-lite .results,
.performance-lite .trailer-action,
.platform-webos #mobileheads {
  -webkit-backdrop-filter: none !important;
  backdrop-filter: none !important;
}
.platform-webos .media-backdrop {
  left: 0 !important;
  width: 100% !important;
  max-width: none !important;
  transform: none !important;
}
.platform-webos .trailer-poster-fill {
  filter: none !important;
  transform: none !important;
  opacity: .28;
}
.platform-webos .trailer-hero-frame {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  min-width: 0 !important;
  height: 100% !important;
  min-height: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
  transform: none !important;
}
.platform-webos .trailer-poster-shell {
  z-index: 2 !important;
  visibility: visible !important;
}
.platform-webos .trailer-frame-ready .trailer-poster-shell {
  visibility: hidden !important;
}
.platform-webos .anime:hover,
.platform-webos .anime-selected,
.platform-webos .poster-link {
  filter: none !important;
  transform: none !important;
  box-shadow: none !important;
}
.platform-webos .kind-badge,
.platform-webos .watch-action,
.platform-webos .remove-action,
.platform-webos .library-complete {
  -webkit-backdrop-filter: none !important;
  backdrop-filter: none !important;
}
.platform-webos .content_img img {
  filter: none !important;
  transform: none !important;
  transition: none !important;
}
.platform-webos a:focus,
.platform-webos button:focus,
.platform-webos input:focus,
.platform-webos select:focus,
.platform-webos textarea:focus,
.platform-webos [tabindex]:focus {
  outline: 3px solid #fff !important;
  outline-offset: 4px !important;
}
.platform-webos iframe[data-tv-player]:focus {
  outline: 4px solid #fff !important;
  outline-offset: -4px !important;
}
.platform-webos .nav-item {
  min-height: 52px !important;
  font-size: 20px !important;
}
.platform-webos .trailer-action,
.platform-webos .basic_information .watch,
.platform-webos .basic_information .btn1 {
  min-height: 56px !important;
  font-size: 18px !important;
}
.platform-webos .source-switcher button {
  min-height: 60px !important;
  font-size: 17px !important;
}
.platform-webos .media-title {
  font-size: 18px !important;
}
.platform-webos .player-back {
  position: fixed !important;
  z-index: 20 !important;
  top: 14px !important;
  left: 14px !important;
  display: inline-flex !important;
  min-height: 48px !important;
  box-sizing: border-box;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, .35);
  border-radius: 999px;
  background: rgba(0, 0, 0, .88);
  color: #fff;
  padding: 0 18px;
  font: 600 16px/1 Inter, sans-serif;
  text-decoration: none;
}
.platform-webos *,
.performance-lite .trailer-artwork-next,
.performance-lite .trailer-hero-frame {
  scroll-behavior: auto !important;
  transition-duration: 0.01ms !important;
}

@media (hover: none), (pointer: coarse) {
  .anime:hover {
    filter: none !important;
    box-shadow: none !important;
    transform: none !important;
  }
}

@media (min-width: 1001px) and (max-height: 800px) {
  .platform-webos .basic_information {
    margin-top: 100px !important;
  }
  .platform-webos .basic_information #img {
    width: 270px !important;
    height: 399px !important;
    flex-basis: 270px !important;
  }
  .platform-webos .basic_information .further_information {
    margin-left: 38px !important;
  }
  .platform-webos .basic_information .title {
    font-size: 38px !important;
  }
  .platform-webos .basic_information .description {
    font-size: 19px !important;
  }
}
</style>
